import React from "react";
import { ActivityIndicator, StyleSheet, View } from "react-native";

import AboutUserTab from "../Tabs/AboutUser/AboutUserTab";
import PrivatePhotoTab from "../Tabs/PrivatePhotosTab";
import PublicPhotoTab from "../Tabs/PublicPhotosTab";

import { ProfileScreenTab } from "./ProfileHeader/ProfileTabs";

import { type UserProfile } from "@/schemas/user/profile";
import { type AppUserSession } from "@/schemas/auth/session";

type ProfileContentProps = {
  session: AppUserSession;
  profile: UserProfile;
  selectedTab: string;
};

function ProfileContent({
  session,
  profile,
  selectedTab,
}: ProfileContentProps): React.JSX.Element {
  const renderTabContent = (): React.JSX.Element => {
    switch (selectedTab) {
      case ProfileScreenTab.PUBLIC:
        return <PublicPhotoTab session={session} profile={profile} />;
      case ProfileScreenTab.PRIVATE:
        return <PrivatePhotoTab session={session} profile={profile} />;
      case ProfileScreenTab.ABOUT:
        return <AboutUserTab attributes={profile.attributes} />;
      case ProfileScreenTab.MESSAGE:
        return <ActivityIndicator />;
      default:
        return <></>;
    }
  };

  return <View style={styles.container}>{renderTabContent()}</View>;
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

export default ProfileContent;
